'use client';
import React, { useEffect, useState } from "react";
import { isBrowser } from '@spot-fe/utils';
import H5Landing from './h5Landing';
import Splash from './splash';
import styles from './index.module.scss';

export default function Index(props) {

  const [deviceType, setDeviceType] = useState<'pc' | 'mobile'>();
  const handleResize = () => {
    const MOBILE_MAX_WIDTH = 1199;
    if (isBrowser && document?.body?.offsetWidth < MOBILE_MAX_WIDTH) {
      setDeviceType('mobile');
    } else {
      setDeviceType('pc');
    }
  };

  useEffect(() => {
    handleResize();
    if (deviceType === 'mobile') {
      document.querySelector('html')?.classList.add('moly-theme-dark');
    } else {
      document.querySelector('html')?.classList.add('moly-theme-light');
    }
    window?.addEventListener('resize', handleResize);
    return () => {
      window?.removeEventListener('resize', handleResize)
    }
  }, [deviceType])

  switch (deviceType) {
    case 'mobile':
      return <H5Landing />;
    case 'pc':
      return (
        <div>
          <Splash />
        </div>
      )
    default:
      return <div className={styles.loading}></div>;
  }
}
